import { render } from "./AdminProgramas.vue?vue&type=template&id=a816b8a0"
import script from "./AdminProgramas.vue?vue&type=script&lang=js"
export * from "./AdminProgramas.vue?vue&type=script&lang=js"

import "./AdminProgramas.vue?vue&type=style&index=0&id=a816b8a0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__